import { inject } from 'vue'

import {
  SHOPPING_ASSISTANT_HOST_KEY,
  type ShoppingAssistantHost,
} from './useShoppingAssistantHost.injection-key'

/**
 * Injects the host adapter provided by the surrounding shell (webview or web).
 * Throws when used outside a host, since the core cannot function without one.
 */
export function useShoppingAssistantHost(): ShoppingAssistantHost {
  const host = inject(SHOPPING_ASSISTANT_HOST_KEY)

  if (!host) {
    throw new Error(
      '[SHOPPING_ASSISTANT] useShoppingAssistantHost must be used within a component that provides SHOPPING_ASSISTANT_HOST_KEY',
    )
  }

  return host
}
